import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

interface EmailEvent {
  type: string
  timestamp: string
  transport?: string
  url?: string
}

interface Email {
  id: string
  from: string
  to: string[]
  status: string
  transport: string | null
  ip: string | null
  marketing: boolean
  transactional: boolean
  created_at: string
  sent_at: string | null
  delivered_at: string | null
  opens: number
  clicks: number
  events: EmailEvent[]
}

interface EmailListResponse {
  data: Email[]
  pagination: {
    page: number
    per_page: number
    total: number
  }
}

interface EmailListParams {
  page?: number
  per_page?: number
  status?: string
  search?: string
  domain?: string
  transport?: string
  from?: string
  to?: string
  api_key_id?: string
  type?: string
}

const QUERY_KEY = ['emails'] as const

export function useEmails(
  params?: EmailListParams,
): ReturnType<typeof useQuery<EmailListResponse>> {
  return useQuery({
    queryKey: [...QUERY_KEY, params],
    queryFn: () => apiClient.get<EmailListResponse>(endpoints.emails.list(params)),
  })
}

export function useEmail(id: string): ReturnType<typeof useQuery<Email>> {
  return useQuery({
    queryKey: [...QUERY_KEY, id],
    queryFn: () => apiClient.get<Email>(endpoints.emails.detail(id)),
    enabled: !!id,
  })
}

export type { Email, EmailEvent, EmailListParams, EmailListResponse }
